import { useEffect, useRef } from "react";
import { ChromePicker } from "react-color";

export default function ColorPicker({
  blockPickerColor,
  setBlockPickerColor,
  visible,
  onClose,
  ignoreRefs = [],
}) {
  const pickerRef = useRef(null);

  useEffect(() => {
    if (!visible) return undefined;

    const handlePointerDown = (event) => {
      const target = event.target;
      const insidePicker = pickerRef.current?.contains(target);
      const insideIgnored = ignoreRefs.some((ref) =>
        ref?.current?.contains(target),
      );
      if (!insidePicker && !insideIgnored) {
        onClose?.();
      }
    };

    const handleEscape = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className="color-picker-popover" ref={pickerRef} role="dialog">
      <ChromePicker
        disableAlpha
        color={blockPickerColor || "#000000"}
        onChange={(color) => {
          setBlockPickerColor(color.hex);
        }}
      />
    </div>
  );
}
